import React, { Component } from 'react';

class EventImagesCarousel extends Component {
  render() {
    return (
      <div>
        
      </div>
    );
  }
}

export default EventImagesCarousel;
